module.exports = __webpack_public_path__ + "img/STERiJECT_02_1.3ade2acc.png";